import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment/moment';
import { clearRows } from '../../../Redux/actions/rowActions';
import { useDispatch } from 'react-redux';
import "../pagination/pagination.css"
import { IoAddSharp } from "react-icons/io5";
import Pagination from '../pagination/pagination';
import Select from 'react-select';
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from '../../services/apiService';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import CheckboxSetFilter from '../gridFilter/checkboxSetFilter';
import { useTranslation } from 'react-i18next';
import SingleInvoice from './singleInvoice';
import { Modal } from 'react-bootstrap';
const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL

const SingleInvoiceListing = () => {
    const { t } = useTranslation(['singleInvoice', 'common']);
    const [showAddModal, setShowAddModal] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [proprtyList, setProperty] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [unitList, setUnitList] = useState([])
    const apiService = new LeaseApiService();
    const { currencyPrecision } = useCurrency();
    const [FilterTab, setFilterTab] = useState(true);
    const [permissions, setPermissions] = useState([]);
    const [contextMenu, setContextMenu] = useState(null);
    const [periodFrom, setPeriodFrom] = useState("");
    const [periodTo, setPeriodTo] = useState("");
    let navigate = useNavigate()
    let dispatch = useDispatch()
    const [formData, setFormData] = useState({
        fromDate: "",
        toDate: "",
        Proprty: [{ label: 'Select Property', value: '' }],
        unitNo: [{ label: 'Select Unit No', value: '' }]
    })
    const formatDat = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        const today = new Date();

        // First day of current month
        const firstDayCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);

        // First day of next month
        const firstDayNextMonth = new Date(today.getFullYear(), today.getMonth() + 1, -1);

        setPeriodFrom(formatDat(firstDayCurrentMonth));
        setPeriodTo(formatDat(firstDayNextMonth));

        const handleClickOutside = () => setContextMenu(null);

        window.addEventListener("click", handleClickOutside);

        return () => window.removeEventListener("click", handleClickOutside);
    }, []);
    useEffect(() => {
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        const permissions = storedPermissions?.filter(acc => acc.formName === "Lease Receipt");
        setPermissions(permissions[0]);
    }, [])
    useEffect(() => {
        getItems();
        fetchDropdownData();
    }, [])
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'ReceiptPropertyNos');
            const res = await apiService.getApiParamater('RECEIPT_DROPDOWN', `?${params.toString()}`);
            setProperty([{ value: 'All', text: 'All' }, ...res?.data?.dropdowns?.PropertyNo]);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handlePrint = (rowData) => {
        if (rowData) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase")
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup";

                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "RecordId", value: rowData?.tranId },
                    { name: "LeaseNo", value: rowData?.leaseNo },
                    { name: "ReceiptNo", value: rowData?.invoiceNo },
                    { name: "reportName", value: 'SINGLEINV' },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', 50);
            params.append('PropertyNo', formData?.Proprty?.value?.value || 'All');
            params.append('UnitNo', formData?.unitNo?.label || 'All');
            params.append('Mode', 'EDIT');
            params.append('TenantNo', 'All');
            params.append('LeaseNo', 'All');
            params.append('UnitType', 'All');
            params.append('FromDate', periodFrom);
            params.append('ToDate', periodTo);

            const res = await apiService.getApiParamater('GET_SINGLE_INVOICE', `?${params.toString()}`);
            // let gridData = res?.data?.result?.filter((temp) => temp?.tranId != 0);
            // let gridData = res?.data?.result?.filter((temp) => temp?.tranId != 0)?.sort((a, b) => a.tranId - b.tranId); accending
            let gridData = res?.data?.result?.filter((temp) => temp?.tranId != 0)?.sort((a, b) => b.tranId - a.tranId);

            setRowData(gridData || []);
            setPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const SearchItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append('PageNo', 1);
            params.append('PageSize', 50);
            params.append('PropertyNo', formData?.Proprty?.value?.value || 'All');
            params.append('UnitNo', formData?.unitNo?.label || 'All');
            params.append('Mode', 'EDIT');
            params.append('TenantNo', 'All');
            params.append('LeaseNo', 'All');
            params.append('UnitType', 'All');
            params.append('FromDate', periodFrom);
            params.append('ToDate', periodTo);

            const res = await apiService.getApiParamater('GET_SINGLE_INVOICE', `?${params.toString()}`);
            // let gridData = res?.data?.result?.filter((temp) => temp?.tranId != 0);
            // let gridData = res?.data?.result?.filter((temp) => temp?.tranId != 0)?.sort((a, b) => a.tranId - b.tranId); accending
            let gridData = res?.data?.result?.filter((temp) => temp?.tranId != 0)?.sort((a, b) => b.tranId - a.tranId);
            setRowData(gridData || []);
            setPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const numberValueFormatter = function (params) {
        return params?.value;
    }
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    };
    const handleMenuAction = (action, rowData) => {
        if (action === 'print') {
            handlePrint(rowData);
        }
        setContextMenu(null); // Close the menu
    };
    const columnDefs = [
        {
            headerName: '', field: 'recordId', cellRenderer: BtnCellRenderer, pinned: 'left',
            cellRendererParams: {
                clicked: function (field, exp2) {
                    handleMenuAction(field, exp2);
                },
            }, width: 30,
        },
        {
            headerName: t('singleInvoice:columns.leaseNo'), field: 'leaseNo', filter: CheckboxSetFilter,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 170, pinned: 'left'
        },
        {
            headerName: t('singleInvoice:columns.leaseStart'), field: "leaseStart", filter: CheckboxSetFilter,
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 136
        },
        {
            headerName: t('singleInvoice:columns.leaseEnd'), field: "leaseEnd", filter: CheckboxSetFilter,
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 136
        },
        {
            headerName: t('singleInvoice:columns.invoiceNo'), field: 'invoiceNo', filter: CheckboxSetFilter, suppressMovable: true, width: 150,
            // valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers)
        },
        {
            headerName: t('singleInvoice:columns.invoiceDate'), field: "invoiceDate", filter: CheckboxSetFilter,
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 136
        },
        {
            headerName: t('singleInvoice:columns.narration'), field: "description", filter: CheckboxSetFilter, suppressMovable: true, width: 300
        },
        {
            headerName: t('singleInvoice:columns.tenantName'), field: 'tenantName', filter: CheckboxSetFilter,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 300
        },
        {
            headerName: t('singleInvoice:columns.propertyName'), field: 'propertyName',
            valueFormatter: numberValueFormatter, filter: CheckboxSetFilter, suppressMovable: true, width: 200
        },
        {
            headerName: t('singleInvoice:columns.unitNo'), field: 'unitNo', filter: CheckboxSetFilter,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 120
        },
        {
            headerName: t('singleInvoice:columns.amount'), field: 'amount', filter: CheckboxSetFilter, suppressMovable: true, width: 150,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.decimalNumbers)
        },
    ]
    const clearAllRows = () => {
        dispatch(clearRows());
    }
    const handlenew = () => {
        clearAllRows();
        setShowAddModal(true);
    }
    const handleClearFilters = () => {
        setFormData({
            receiptNo: "",
            Proprty: [{ label: 'Select Property', value: '' }],
            Status: [{ label: 'All', value: '' }],
        });
    }
    const handlePropertyChange = async (selectedOption) => {
        if (selectedOption?.value?.value === "All") {
            setFormData({
                ...formData,
                Proprty: selectedOption,
                unitNo: [{ label: '', value: '' }]
            });
        } else {
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRSearchUnitNosByPropertyId');
            params.append('CascadValue', selectedOption?.value?.value);
            const res = await apiService.getApiParamater('CASCAD_DROP', `?${params.toString()}`);
            setUnitList([{ value: 'All', text: 'All' }, ...res?.data?.items]);
            setFormData({
                ...formData,
                Proprty: selectedOption,
                unitNo: [{ label: '', value: '' }]
            });
        }

    }
    const handleUitNo = (selectedOption) => {
        setFormData({ ...formData, unitNo: selectedOption });
    }
    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // month is 0-based
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    const handlePeriodFromChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodFrom(formattedDate);
    }
    const handlePeriodToChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodTo(formattedDate);
    }
    return (
        <div className='p-3 '>
            <div className="cost-center-section">
                <div className="d-flex  cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}>
                    <div className='h6 pt-1'>{t('common:searchParameters')}</div>
                </div>
                <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                        <div className='row'>
                            <div className='col-4'>
                                <Select
                                    className="p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={formData.Proprty}
                                    onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                    options={proprtyList?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className='col-4'>
                                <Select
                                    className="p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={formData.unitNo}
                                    onChange={(selectedOption) => handleUitNo(selectedOption)}
                                    options={unitList?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className='col d-flex gap-2'>
                                <div
                                    onClick={() => SearchItems()}
                                    className='mainbtnGry flex-end gap-2 w-50'>
                                    <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>{t('common:search')}</div>
                                </div>
                                <div
                                    onClick={() => handleClearFilters()}
                                    className='mainbtnRed flex-end gap-2 w-50'>
                                    <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>{t('common:reset')}</div>
                                </div>
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-4 d-flex gap-3'>
                                <label className='center w-25'>{t('common:fromDate')}</label>
                                <DatePicker
                                    todayButton="Today"
                                    selected={periodFrom}
                                    onChange={(date) => handlePeriodFromChange({ name: 'leaseDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className='col-4 d-flex gap-3'>
                                <label className='center w-25'>{t('singleInvoice:leaseExpiry')}</label>
                                <DatePicker
                                    todayButton="Today"
                                    selected={periodTo}
                                    onChange={(date) => handlePeriodToChange({ name: 'toDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='border-box2 p-4'>
                {loading ? (
                    <div>{t('common:loading')}</div>
                ) : (
                    <>
                        <div className='d-flex justify-contant-between '>
                            <h5 className='col mainInvHead'>{t('singleInvoice:listTitle')}</h5>
                            <div className='d-flex justify-content-end gap-1'>
                                {/* {permissions?.canAdd === true ? */}
                                <div className='col center'>
                                    <button className='mainbtn ' type="submit" onClick={() => handlenew()}>
                                        <IoAddSharp color='#fff' className='center mt-1' /> <div>{t('common:add')}</div>
                                    </button>
                                </div>
                                {/* } */}
                            </div>
                        </div>
                        <div className='gridshad  mt-3'>
                            <div className="ag-theme-quartz" style={{ height: 510 }}>
                                <AgGridReact
                                    getRowStyle={(params) => {
                                        if (params.node.rowIndex % 2 === 0) {
                                            return { background: '#F0EDF5' };
                                        } else {
                                            return { background: '#fff' };
                                        }
                                    }}
                                    rowData={rowData}
                                    columnDefs={columnDefs}
                                    enableFilter={true}
                                    frameworkComponents={{ BtnCellRenderer }}
                                    context={{ setContextMenu }}
                                />
                            </div>
                            <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
                        </div>
                    </>
                )}
            </div>
            {contextMenu && (
                <div
                    style={{
                        position: 'absolute',
                        top: contextMenu.mouseY,
                        left: contextMenu.mouseX,
                        backgroundColor: 'white',
                        border: '1px solid gray',
                        zIndex: 1000,
                        padding: '10px 30px',
                        borderRadius: '8px',
                        boxShadow: '0px 2px 6px rgba(0,0,0,0.2)'
                    }}
                >
                    <button className="btn btn-secondary " onClick={() => handleMenuAction('print', contextMenu.data)}>
                        {t('singleInvoice:print')}
                    </button>
                </div>
            )}
            <Modal
                show={showAddModal}
                size="xl"
                scrollable
                centered
                onHide={() => setShowAddModal(false)}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t('singleInvoice:generateTitle')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <SingleInvoice
                        onClose={() => setShowAddModal(false)}
                        onSaved={() => {
                            setShowAddModal(false);
                            getItems();
                        }}
                    />
                </Modal.Body>
            </Modal>
        </div>
    );
};

class BtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.stopPropagation(); // Prevent row selection
        const { context, data } = this.props;

        if (context && context.setContextMenu) {
            context.setContextMenu({
                mouseX: e.clientX,
                mouseY: e.clientY,
                data: data
            });
        }
    }

    render() {
        return (
            <div className='center'>
                <span onClick={this.handleClick} style={{ cursor: 'pointer', fontSize: '30px' }}>
                    &#8942; {/* Vertical Ellipsis */}
                </span>
            </div>
        );
    }
}
export default SingleInvoiceListing;